import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/goods/` + url, ...arg)

/**
 * 商品列表Api接口管理器
 *
 * @author gim
 * @date  2025/06/07 10:08
 **/
export default {
	// 获取商品列表
	tradeGoodsRecordAll(data) {
		return request('all', data, 'get')
	},
}
